module.exports = __webpack_public_path__ + "static/media/toy.f19204b9.jpg";